import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TlkBannerComponent } from '@itero/ui-toolkit-angular/banner';
import { TlkButtonComponent } from '@itero/ui-toolkit-angular/button';
import { CloseEmptyIconComponent } from '@itero/ui-toolkit-angular/icons';
import { timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BaseDestroyableComponent } from '@shared/base-classes/base-destroyable';

@Component({
	selector: 'rx-banner-dismissible',
	templateUrl: './rx-banner-dismissible.component.html',
	styleUrls: ['./rx-banner-dismissible.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [TlkBannerComponent, TlkButtonComponent, CloseEmptyIconComponent, TranslateModule]
})
export class RxBannerDismissibleComponent extends BaseDestroyableComponent implements OnInit {
	@Input() type: 'error' | 'warning' | 'info' | 'success' = 'info';
	@Input() autoDismiss = true;

	@Output() dismissed = new EventEmitter<void>();

	private readonly AUTO_DISMISS_MS = 10000;

	ngOnInit(): void {
		if (!this.autoDismiss) {
			return;
		}

		timer(this.AUTO_DISMISS_MS)
			.pipe(takeUntil(this.componentAlive$))
			.subscribe(() => this.dismissed.emit());
	}

	onDismiss(): void {
		this.dismissed.emit();
	}
}
